import React, {useCallback, useState} from "react";
import {Button, Input, Space} from "antd";
import {PictureOutlined, PlayCircleOutlined} from "@ant-design/icons";
import {toVideoTime} from '../../../util/time'

export default function CatalogueContentItem({data, level = 2, OpenCourseModal, onSort}) {
    const [sort, setSort] = useState(data.sort)
    const onSortChange = useCallback(()=>{
        if (sort !== data.sort) {
            onSort(data.courseInfoId,sort)
        }
    })

    return (<div className="flexbox align-center justifyBetween border-bottom pdv8"
             style={{paddingLeft: (level - 1) * 32}}>
            <div className="flexbox align-center">
                <Input
                    className="text-center"
                    style={{borderRadius: 0, width: 20, height: 20, padding: 0}}
                    type="number"
                    min={0}
                    value={sort}
                    onChange={e=>setSort(e.target.value)}
                    onBlur={onSortChange}
                />
                {data.typeCode === 1 && <PlayCircleOutlined className="fts-18 gray-light mgl8"/>}
                {data.typeCode === 2 && <PictureOutlined className="fts-18 gray-light mgl8"/>}
                <span className="bold fts-14 mgl8">{data.courseInfoName}</span>
                {data.typeCode === 1 && <span className="fts-13 mgl40">{toVideoTime(data.totalNumber)}</span>}
                {data.typeCode === 2 && <span className="fts-13 mgl40">共{data.totalNumber}页</span>}
            </div>
            <Space>
                <Button onClick={OpenCourseModal}>修改</Button>
            </Space>
        </div>)
}